import CourseDetails from "../pages/coursedetails";
import React from "react";

export const CourseDetail = () => {
  return <CourseDetails />;
};
